import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../../components/common/general/CustomText/CustomText";
import { colors, radii, spacing } from "../../../../styles/design-system";
import { clampPercentage } from "../../../../utils/analyticsUtils";

type QuestionPerformanceRowProps = {
  label: string;
  correctPct: number;
  detail?: string | null;
};

const QuestionPerformanceRow: React.FC<QuestionPerformanceRowProps> = ({ label, correctPct, detail }) => {
  const safePct = Math.round(clampPercentage(correctPct));
  const isWeak = safePct < 70;
  const barColor = isWeak ? colors.error[500] : colors.success[500];
  const textColor = isWeak ? colors.error[600] : colors.success[700];

  return (
    <View style={styles.container}>
      <CustomText text={label} size="s" weight="medium" useTranslationText={false} />
      <View style={styles.progressRow}>
        <View style={styles.track}>
          <View style={[styles.fill, { width: `${safePct}%`, backgroundColor: barColor }]} />
        </View>
        <CustomText text={`${safePct}% correct`} size="xs" useTranslationText={false} style={{ color: textColor }} />
      </View>
      {detail ? <CustomText text={detail} size="xs" useTranslationText={false} style={styles.helperText} /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: colors.grey[200],
    borderRadius: 10,
    backgroundColor: colors.white,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    gap: spacing.xs,
  },
  progressRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing.sm,
  },
  track: {
    flex: 1,
    height: 8,
    borderRadius: radii.full,
    backgroundColor: colors.grey[200],
    overflow: "hidden",
  },
  fill: {
    height: "100%",
    borderRadius: radii.full,
  },
  helperText: {
    color: colors.grey[500],
  },
});

export default QuestionPerformanceRow;
